// © 2015-2021 WDNA - All Rights Reserved

import * as React from 'react';

/**
 * Returns an error jsx element
 *
 * @returns react element
 */
export default function EmptyPage(): JSX.Element {
  return <div />;
}
